import { forwardRef, useImperativeHandle, useRef } from 'react';
import { ICellEditor, ICellEditorParams } from 'ag-grid-community';
import { Button } from '@mui/material';

export const LinkCellEditor = forwardRef<
  ICellEditor,
  ICellEditorParams & { text?: string; onClick?: (rowId: number | null) => void }
>((props, ref) => {
  const refButton = useRef<HTMLButtonElement>(null);

  const value = props.value ?? '';
  const rowId = props.node?.data?.id ?? null;

  useImperativeHandle(ref, () => ({
    afterGuiAttached() {
      refButton.current?.focus();
    },
    getValue() {
      return value;
    },
    isCancelBeforeStart() {
      return false;
    },
    isCancelAfterEnd() {
      return false;
    },
  }));

  return (
    <Button variant="text" onClick={() => props.onClick?.(rowId)} sx={{ textTransform: 'none' }}>
      {props.text ?? props.value}
    </Button>
  );
});

LinkCellEditor.displayName = 'LinkCellEditor';
